import { useSelector } from 'react-redux';
import { Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { selectLocale } from '@app/redux/locale';
import { selectCurrentPlanPrice } from '@app/redux/plan';

import { Locale } from '@mfe/shared/schema-types';

import loadingStyles from './Loading.module.scss';

export const Price = () => {
  const { t } = useTranslation('Global');

  const { price, loading, errors } = useSelector(selectCurrentPlanPrice);

  const {
    locale: { userLocale },
  } = useSelector(selectLocale);

  if (userLocale === Locale.PtBr || errors) {
    return null;
  }

  if (loading) {
    return <div className={loadingStyles['price']} />;
  }

  if (!price) {
    return null;
  }

  return <Txt variant={'heading2'}>{t('price', { price: Number(price), context: 'fixed' })}</Txt>;
};
